import React from "react";
import Button from "@material-ui/core/Button";
import { languages } from "../constants/languages";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import FileUploader from "react-firebase-file-uploader";
import DeleteIcon from "@material-ui/icons/Delete";
import UploadIcon from "@material-ui/icons/CloudUpload";
import CircularProgress from "@material-ui/core/CircularProgress";
import { validateFileSize } from "../util/uploadErrors";

export default class EditSponsorElement extends React.Component {
  render() {
    return (
      <div>
        {this.props.errorMessage && (
          <Typography style={{ color: "red" }}>{this.props.errorMessage}</Typography>
        )}
        {/* <Typography variant="h6">{languages.tournament.sponsor}</Typography> */}
        {/* <TextField
          margin="dense"
          label={languages.general.nameSponsor}
          value={this.props.sponsorName}
          name="sponsorName"
          onChange={this.props.handleSponsorNameChange}
          type="text"
          fullWidth
        /> */}
        <Paper style={{ width: "100%" }}>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              height: 180,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {this.props.isUploading ? (
              <CircularProgress size={28} />
            ) : this.props.sponsorLogoURL ? (
              <img
                style={{
                  maxWidth: "100%",
                  maxHeight: 180,
                  margin: "auto",
                  verticalAlign: "middle",
                }}
                src={this.props.sponsorLogoURL}
                alt=""
              />
            ) : (
              <Typography
                style={{
                  color: "gray",
                  display: "inline-block",
                  width: "100%",
                  textAlign: "center",
                }}
              >
                {languages.tournament.logo}
              </Typography>
            )}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              width: "100%",
            }}
          >
            <FileUploader
              id={"upload-sponsor-element"}
              style={{ display: "none" }}
              accept="image/*"
              name="sponsorUpload"
              randomizeFilename
              storageRef={this.props.sponsorStorageRef}
              beforeUploadStart={(file) => {
                validateFileSize(file, 1);
              }}
              onUploadStart={this.props.handleUploadStart}
              onUploadError={(error) => {
                this.props.handleUploadError(error);
              }}
              onUploadSuccess={(fileName) => {
                this.props.handleUploadSuccess(fileName);
              }}
              onProgress={this.props.handleProgress}
            />
            <label
              htmlFor={
                this.props.allowedToUpload ? "upload-sponsor-element" : ""
              }
              style={{
                width: this.props.sponsorLogoURL ? "" : "100%",
                textAlign: "center",
              }}
            >
              <Button
                size="small"
                variant="text"
                component="span"
                color="primary"
                onClick={
                  !this.props.allowedToUpload
                    ? this.props.toggleUpgradeDialog
                    : () => {}
                }
                fullWidth={this.props.sponsorLogoURL ? false : true}
              >
                <UploadIcon />
              </Button>
            </label>
            {this.props.sponsorLogoURL && (
              <Button
                size="small"
                variant="text"
                color="secondary"
                onClick={this.props.handleDeleteSponsor}
              >
                <DeleteIcon />
              </Button>
            )}
          </div>
        </Paper>
      </div>
    );
  }
}
